var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      color: "#222"
    },
    viewBox: "0 0 105 105"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m45.39 36 22.608 16.608L45.39 69.215z",
    style: {
      stroke: "currentColor"
    }
  }));
};
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDUgMTA1IiBmaWxsPSJub25lIj4KICA8c3R5bGU+CiAgICAgIHN2ZyB7IGNvbG9yOiAjMjIyMjIyOyB9CgogICAgICAudHJpYW5nbGUgewogICAgICAgIHN0cm9rZTogY3VycmVudENvbG9yOwogICAgICB9CiAgPC9zdHlsZT4KICA8Y2lyY2xlIGN4PSI1Mi41IiBjeT0iNTIuNSIgcj0iNTIuNSIgZmlsbD0id2hpdGUiLz4KICA8cGF0aCBkPSJNNDUuMzkgMzZMNjcuOTk4IDUyLjYwOEw0NS4zOSA2OS4yMTQ1IHoiIGNsYXNzPSJ0cmlhbmdsZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPC9zdmc+";